import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MessageService } from './services/message.service';

/**
 * Components
 */
import { Footer } from './components/footer/footer.component';
import { CommonHeader } from './components/common-header/common-header.component';
import { CustomTranslationLoader } from '../app/services/custom-translation-loader';

@NgModule({
  declarations: [
    CommonHeader,
    Footer
  ],
  imports: [
    TranslateModule.forChild({
      loader: { 
        provide: TranslateLoader, 
        useClass: CustomTranslationLoader
      }
    }),
    CommonModule,
    RouterModule   
  ],
  providers: [
    MessageService
  ],
  exports : [
    CommonHeader,
    Footer
  ]
})
export class SharedAllModule {
  
}
